import { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';

import Logo from '../../assets/logo/Logo.png';
import './Navbar.css';

export default function NavbarComponent() {
    const location = useLocation();
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        const hash = location.hash;
        if (hash) {
            const element = document.getElementById(hash.replace("#", ""));
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    const isActive = (path) => location.pathname === path;

    const isProfesoriActive = ['/titularizare', '/definitivat', '/grade', '/olimpiade'].includes(location.pathname);
    const isMeditatiiActive = ['/meditatii-elevi', '/meditatii-studenti', '/meditatii-profesori'].includes(location.pathname);

    return (
        <Container>
            <Navbar fixed="top" expand="xxl" className="navbarBackground worldwide">
                <Navbar.Brand as={Link} to="/">
                    <img src={Logo} className="logoNavbar" alt="LogoNavbar"/>
                </Navbar.Brand>
                <Navbar.Toggle 
                    aria-controls="offcanvasNavbar" 
                    onClick={handleShow} 
                    className="custom-toggler"
                />
                <Navbar.Offcanvas
                    id="offcanvasNavbar"
                    aria-labelledby="offcanvasNavbarLabel"
                    placement="start"
                    show={show}
                    onHide={handleClose}
                    className="custom-offcanvas"
                >
                    <Offcanvas.Header closeButton closeVariant="white">
                        <Offcanvas.Title id="offcanvasNavbarLabel">
                            <img src={Logo} className="logoNavbar" alt="LogoNavbar"/>
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body className="d-flex flex-column flex-xxl-row justify-content-xxl-between align-items-xxl-center">
                        <Nav className="mx-auto navbarContainer align-items-xxl-center">
                            <span className="d-none d-xxl-inline tag-symbol" style={{paddingLeft: "20px"}}>{'<'}</span>
                            
                            <Nav.Link as={Link} to="/" className={`navbarText ${isActive('/') ? 'is-active' : ''}`} onClick={handleClose}>Acasă</Nav.Link>
                            <Nav.Link as={Link} to="/despre" className={`navbarText ${isActive('/despre') ? 'is-active' : ''}`} onClick={handleClose}>Despre</Nav.Link>
                            <Nav.Link href="/cv/CV Crantea Antonio-Cristian.pdf" className="navbarText" target="_blank" rel="noopener noreferrer" onClick={handleClose}>CV</Nav.Link>
                            <Nav.Link as={Link} to="/portofoliu" className={`navbarText ${isActive('/portofoliu') ? 'is-active' : ''}`} onClick={handleClose}>Portofoliu</Nav.Link>
                            
                            <NavDropdown 
                                className={`navbarText custom-dropdown ${isMeditatiiActive ? 'is-active' : ''}`} 
                                title="Meditații" 
                                id="meditatii-nav-dropdown"
                            >
                                <NavDropdown.Item as={Link} to="/meditatii-elevi" className={isActive('/meditatii-elevi') ? 'is-active-item' : ''} onClick={handleClose}>Elevi</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/meditatii-studenti" className={isActive('/meditatii-studenti') ? 'is-active-item' : ''} onClick={handleClose}>Studenți</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/meditatii-profesori" className={isActive('/meditatii-profesori') ? 'is-active-item' : ''} onClick={handleClose}>Profesori</NavDropdown.Item>
                            </NavDropdown>

                            <NavDropdown 
                                className={`navbarText custom-dropdown ${isProfesoriActive ? 'is-active' : ''}`} 
                                title="Profesori" 
                                id="profesori-nav-dropdown"
                            >
                                <NavDropdown.Item href="https://arhiva-info-tic.ro/" target="_blank" rel="noopener noreferrer" onClick={handleClose}>Arhiva Info-TIC</NavDropdown.Item>
                                <NavDropdown.Divider/>
                                <NavDropdown.Item as={Link} to="/titularizare" className={isActive('/titularizare') ? 'is-active-item' : ''} onClick={handleClose}>Titularizare</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/definitivat" className={isActive('/definitivat') ? 'is-active-item' : ''} onClick={handleClose}>Definitivat</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/grade" className={isActive('/grade') ? 'is-active-item' : ''} onClick={handleClose}>Grade</NavDropdown.Item>
                                <NavDropdown.Divider/>
                                <NavDropdown.Item as={Link} to="/olimpiade" className={isActive('/olimpiade') ? 'is-active-item' : ''} onClick={handleClose}>Olimpiade</NavDropdown.Item>
                            </NavDropdown>

                            <Nav.Link as={Link} to="/simulari" className={`navbarText ${isActive('/simulari') ? 'is-active' : ''}`} onClick={handleClose}>Simulări Tit</Nav.Link>
                            <Nav.Link as={Link} to="/algoritmi-si-rezolvari" className={`navbarText ${isActive('/algoritmi-si-rezolvari') ? 'is-active' : ''}`} onClick={handleClose}>Carte Tit / Def</Nav.Link>
                            <Nav.Link as={Link} to="/blog" className={`navbarText ${isActive('/blog') ? 'is-active' : ''}`} onClick={handleClose}>Blog</Nav.Link>
                            <Nav.Link as={Link} to="/subiecte" className={`navbarText ${isActive('/subiecte') ? 'is-active' : ''}`} onClick={handleClose}>Bacalaureat</Nav.Link>
                            
                            <span className="d-none d-xxl-inline tag-symbol" style={{paddingRight: "5px"}}>{'/>'}</span>
                        </Nav>
                        <Nav className="mt-4 mt-xxl-0">
                            <Nav.Link as={Link} to="/contact" onClick={handleClose} className="p-0">
                                <Button className={`navbarButton ${isActive('/contact') ? 'is-active-button' : ''}`}>Contact</Button>
                            </Nav.Link>
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Navbar>
        </Container>
    );
}